import { render, staticRenderFns } from "./GroupCategories.vue?vue&type=template&id=da85cb0a&lang=pug&"
import script from "./GroupCategories.vue?vue&type=script&lang=js&"
export * from "./GroupCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da85cb0a')) {
      api.createRecord('da85cb0a', component.options)
    } else {
      api.reload('da85cb0a', component.options)
    }
    module.hot.accept("./GroupCategories.vue?vue&type=template&id=da85cb0a&lang=pug&", function () {
      api.rerender('da85cb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupCategories.vue"
export default component.exports